import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// The served HTML may be a prerendered page (or the static template) that
// already contains SEO head tags. react-helmet-async does not remove tags it
// didn't create, so strip every helmet-managed tag before mounting — this
// guarantees exactly one title/description/canonical/OG/schema set per page.
// Non-JS crawlers are unaffected: they never run this and keep the served tags.
document.head
  .querySelectorAll(
    'title, meta[name="description"], meta[name="robots"], link[rel="canonical"], script[type="application/ld+json"], meta[property^="og:"], meta[name^="twitter:"]',
  )
  .forEach((el) => el.parentNode.removeChild(el));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
